import { del } from 'idb-keyval'
export const clearStore = async () => {
  await del('role')
}
